import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03505493"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "note-description" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Notiz", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Füge einen Namen und eine Beschreibung hinzu, damit diese als Notiz im Ablauf angezeigt werden. Eine Notiz ist niemals für Nutzer deines Chatbots sichtbar. ", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}